import React from 'react';

import { finishPickedPointMovement } from '../../store/actions/layout/layoutPickingActions';
import { pickedPointMovementCleared } from '../../store/slices/applicationSlice';
import { PointMovementPopover } from '../controls/PointMovementPopover';
import { useAppDispatch, useAppSelector } from '../hooks';

/** Lets the user move a point that was just picked with the movement modifier held, before it is applied. */
export function PendingPickedPointMovementPopover() {
  const dispatch = useAppDispatch();

  const pending = useAppSelector((state) => state.application.pendingPickedPointMovement);
  if (pending == null) return null;

  const { recipient } = pending;
  const recipientKey = recipient.type === 'layoutPointPicking' ? recipient.target : recipient.type;

  return (
    <PointMovementPopover
      // remount for each pending pick so that no input carries over
      key={`${recipientKey}:${pending.point.x}:${pending.point.y}`}
      anchor={{ clientPosition: pending.clientPosition }}
      onMove={(movement) => void dispatch(finishPickedPointMovement(movement))}
      onClose={() => dispatch(pickedPointMovementCleared())}
    />
  );
}
